// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/workload_group.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_published_work } from "./published_work_pb.js";
import { file_studyo_today_schools_v1_resources_student } from "./student_pb.js";
import { file_studyo_today_schools_v1_resources_workload_status } from "./workload_status_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/workload_group.proto.
 */
export const file_studyo_today_schools_v1_resources_workload_group = /*@__PURE__*/
  fileDesc("CjZzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvd29ya2xvYWRfZ3JvdXAucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcyLlAQoNV29ya2xvYWRHcm91cBJBCgZzdGF0dXMYASABKA4yMS5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuV29ya2xvYWRTdGF0dXMSUwoZaW1wb3J0YW50X3B1Ymxpc2hlZF93b3JrcxgCIAMoCzIwLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5QdWJsaXNoZWRXb3JrEjwKCHN0dWRlbnRzGAMgAygLMiouc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzLlN0dWRlbnRCKaoCJlN0dWR5by5Ub2RheS5TY2hvb2xzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_schools_v1_resources_published_work, file_studyo_today_schools_v1_resources_student, file_studyo_today_schools_v1_resources_workload_status]);

/**
 * Describes the message studyo.today.schools.v1.resources.WorkloadGroup.
 * Use `create(WorkloadGroupSchema)` to create a new message.
 */
export const WorkloadGroupSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_workload_group, 0);

